import { render, staticRenderFns } from "./Millages.vue?vue&type=template&id=2b33a846&"
import script from "./Millages.vue?vue&type=script&lang=js&"
export * from "./Millages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports